import { C4CRoutePaths } from "../../constants/Routes";
import C4CDashboard from "../../pages/C4C/Dashboard/C4CDashboard";
import CustomerDashboard from "../../pages/CSAgent/CustomerDashboard/CustomerDashboard";

export const C4CRoutePath = [
   
    {
      path:C4CRoutePaths.DASHBOARD,
      component: C4CDashboard,
    },
    {
      path:C4CRoutePaths.USER_DASHBOARD,
      component: CustomerDashboard,
    },
];